export const picklistTemplateProductFormSchema = {
  type: 'object',
  required: ['picklistTemplateId', 'productId'],
};
